export default class ZaikoData
{
    constructor (year, month)
    {
        this.Year = year;
        this.Month = month;
        // ZaikoDistributor[]
        this.SalesInformation = [];
        // We don't necessarily have to extract
        // this number, but just in case something
        // gets added with a formula in the sheet.
        // Should be SUM of InventoryQuantity + Sum of SalesInformation[].Orders
        this.TotalOrders = null;
        // We have to extract the production cost
        // from the Excel sheet because, as of now,
        // we don't know when to use which price as
        // there may be two different prices.
        this.TotalProductionCost = null;
        this.InventoryQuantity = null;
        this.NumberOfSamples = null;
    }
}